'use strict';

// Module API

var ERROR = 'tableschema.error';
var INFER_THRESHOLD = 10;
var INFER_CONFIDENCE = 0.75;
var DEFAULT_FORMAT = 'csv';
var DEFAULT_ENCODING = 'utf-8';
var DEFAULT_FIELD_TYPE = 'string';
var DEFAULT_FIELD_FORMAT = 'default';
var DEFAULT_MISSING_VALUES = [''];
var IS_BROWSER = typeof window !== 'undefined';

// System

module.exports = {
  ERROR: ERROR,
  INFER_THRESHOLD: INFER_THRESHOLD,
  INFER_CONFIDENCE: INFER_CONFIDENCE,
  DEFAULT_FORMAT: DEFAULT_FORMAT,
  DEFAULT_ENCODING: DEFAULT_ENCODING,
  DEFAULT_FIELD_TYPE: DEFAULT_FIELD_TYPE,
  DEFAULT_FIELD_FORMAT: DEFAULT_FIELD_FORMAT,
  DEFAULT_MISSING_VALUES: DEFAULT_MISSING_VALUES,
  IS_BROWSER: IS_BROWSER
};


//////////////////
// WEBPACK FOOTER
// ./~/tableschema/lib/config.js
// module id = 2
// module chunks = 0